import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { RRIFilter } from '../../../common/interfaces/filters/filter.interface';
import { RRICheckboxOption } from '../../../form-inputs/interfaces/checkbox-option.interface';
import { RRIInput } from '../../../form-inputs/interfaces/input-settings.interface';
import { RRIFilterOption } from '../../../common/interfaces/filters/filter-options.interface';
import { RRIFilterOutput } from '../../../common/interfaces/filters/filter-output.interface';
import { RR_FILTER_TYPE } from '../../../common/enum/filters/filter-type.enum';

@Component({
  selector: 'rr-checkbox-select-filter',
  templateUrl: './checkbox-select-filter.component.html',
  styleUrls: ['./checkbox-select-filter.component.scss'],
})
export class CheckboxSelectFilterComponent<T> implements OnInit {
  @Input() model: RRIFilter<RRIFilterOption<T>[], T>;
  @Input() options: RRIFilterOption<T>[];
  @Input() formComponentSettings: RRIInput<RRICheckboxOption<T>[]>;

  @Output() changedFilter: EventEmitter<RRIFilterOutput<RRIFilterOption<T>[]>> =
    new EventEmitter();

  public checkboxSettings: RRIInput<RRICheckboxOption<T>[]>;

  constructor() {
    this.setDropDownSettings();
  }

  ngOnInit(): void {
    this.setDropDownSettings();
  }

  private setDropDownSettings() {
    if (!this.formComponentSettings) {
      this.checkboxSettings = {
        fieldName: 'filter-checkbox',
        label: '',
      };
      if (!this.model) {
        return;
      }
      this.checkboxSettings.label = this.model?.settings?.title ?? '';
      this.checkboxSettings.placeholder = this.model?.settings?.title ?? '';
      return;
    }
    this.checkboxSettings = this.formComponentSettings;
  }

  public changeCheckbox(selectedOption: RRIFilterOption<T>[]): void {
    this.changedFilter.emit({
      type: RR_FILTER_TYPE.CHECKBOX_SELECT,
      filterBy: {
        ...this.model.filterBy,
        value: selectedOption,
      },
    });
  }
}
